/**
 * @file Affichage du joystick flottant (anneau + bouton) a l'endroit ou le doigt est pose ; invisible sinon.
 */
import { Component } from '../core/Component';
import { h } from '../core/dom';
import type { UiContext } from '../UiContext';

export class JoystickView extends Component {
  private ring!: HTMLElement;
  private knob!: HTMLElement;
  private visible = false;
  private raf = 0;
  private lastRing = '';
  private lastKnob = '';

  constructor(ctx: UiContext) {
    super(ctx, 'div', 'joystick');
  }

  protected build(): void {
    this.ring = h('div', { class: 'ring' });
    this.knob = h('div', { class: 'knob' });
    this.el.append(this.ring, this.knob);
    // Le joystick doit suivre le doigt a la cadence d'affichage (pas a 30 Hz) : boucle rAF propre, arretee a destroy().
    const frame = (): void => {
      this.paint();
      this.raf = requestAnimationFrame(frame);
    };
    this.raf = requestAnimationFrame(frame);
    this.addDisposer(() => cancelAnimationFrame(this.raf));
  }

  override update(_dt: number): void {
    this.paint();
  }

  /**
   * PointerInput fournit des coordonnees RELATIVES a la surface de jeu, qui est aussi le repere du calque joystick (inset 0) :
   * on les applique telles quelles (les retrancher decalait le joystick des que la colonne de jeu est centree sur desktop).
   */
  private paint(): void {
    const j = this.ctx.joystick;
    if (!j.active) {
      if (this.visible) {
        this.visible = false;
        this.el.classList.remove('active');
        this.lastRing = this.lastKnob = '';
      }
      return;
    }
    if (!this.visible) {
      this.visible = true;
      this.el.classList.add('active');
    }
    const ring = `translate3d(${j.originX.toFixed(1)}px, ${j.originY.toFixed(1)}px, 0)`;
    const knob = `translate3d(${j.knobX.toFixed(1)}px, ${j.knobY.toFixed(1)}px, 0)`;
    if (ring !== this.lastRing) {
      this.ring.style.transform = ring;
      this.lastRing = ring;
    }
    if (knob !== this.lastKnob) {
      this.knob.style.transform = knob;
      this.lastKnob = knob;
    }
  }
}
